import { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const email = location.state?.email;
  const otp = location.state?.otp;
  const navigate = useNavigate();

  const handlePasswordReset = async (event) => {
    event.preventDefault();

    if (password !== confirmPassword) {
      toast.error(
        "Passwords do not match. Please ensure both passwords are the same."
      );
      return;
    }

    if (!email || !otp) {
      toast.error("Email or OTP is missing. Please ensure both are provided.");
      return;
    }

    const payload = {
      email,
      otp,
      password,
      password_confirmation: confirmPassword,
    };

    try {
      setLoading(true);
      const response = await axios.post(
        "/super-admin/reset-password",
        payload,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      if (response.data.type === "success") {
        toast.success("Password has been reset successfully.");
        navigate("/dashboard");
      } else {
        toast.error("Failed to reset password. Please try again later.");
        navigate("/request-otp");
      }
    } catch (error) {
      toast.error("Failed to reset password. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="password-reset">
      <div className="reset-input">
        <div className="reset-input-main container">
          <h1>Password Reset</h1>
          <p>Input your details to reset the password</p>
          <form className="password-reset-form" onSubmit={handlePasswordReset}>
            <div className="form-group req">
              <b>
                <label htmlFor="password">New Password</label>
              </b>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Enter your new password"
                autoComplete="new-password"
                autoFill="off"
                data-lpignore="true"
                spellCheck="false"
              />
            </div>
            <div className="form-group req">
              <b>
                <label htmlFor="confirmPassword">Confirm Password</label>
              </b>
              <input
                type="password"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                placeholder="Confirm your new password"
                autoComplete="new-password"
                autoFill="off"
                data-lpignore="true"
                spellCheck="false"
              />
            </div>
            <button type="submit" className="reset-button" disabled={loading}>
              {loading ? "Resetting Password..." : "Reset Password"}
            </button>
          </form>
        </div>
      </div>

      <div className="login-image2"></div>
    </div>
  );
}

export default ResetPassword;
